"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OptionExample_1 = require("./OptionExample");
exports.default = OptionExample_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Select/components/OptionExample/index.js
// module id = 1251
// module chunks = 8